<template>
    <div class="w-full h-full justify-between">
        <!-- <div class="flex space-x-5 w-full justify-start items-center pb-2">
            <div class="flex justify-start items-center w-fit whitespace-nowrap">
                <div class="mr-1 w-5 h-5 rounded bg-emerald-200 border border-gray-300">

                </div>
                <div>
                    Existing Event
                </div>
            </div>
            <div class="flex justify-start items-center w-fit whitespace-nowrap">
                <div class="mr-1 w-5 h-5 rounded bg-sky-200 border border-gray-300">

                </div>
                <div>
                    Valid Row
                </div>
            </div>
            <div class="flex justify-start items-center w-fit whitespace-nowrap">
                <div class="mr-1 w-5 h-5 rounded bg-amber-100 border border-gray-300">

                </div>
                <div>
                    Empty Row
                </div>
            </div>
            <div class="flex justify-start items-center w-fit whitespace-nowrap">
                <div class="mr-1 w-5 h-5 rounded bg-red-400 border border-gray-300">

                </div>
                <div>
                    Invalid Row
                </div>
            </div>
        </div> -->
        <div class='w-full flex overflow-y-scroll'>
            <!-- <div class="w-12  px-2 py-0.5 flex justify-end items-center">
            </div> -->
            <div class="w-full grid grid-cols-12 border-gray-300 rounded-t">
                <div class="w-full bg-gray-50 border-y border-r col-span-1 border-l rounded-tl border-gray-300 px-3 py-1.5 font-semibold">
                    Reorder
                </div>
                <div class="w-full bg-gray-50 border-y border-r col-span-2 border-l rounded-tl border-gray-300 px-3 py-1.5 font-semibold">
                    Detail Name*
                </div>
                <div class="w-full bg-gray-50 border-y border-r  col-span-2 border-gray-300 px-3 py-1.5 font-semibold">
                    Due Date
                </div>
                <div class="w-full bg-gray-50 border-y border-r  col-span-2 border-gray-300 px-3 py-1.5 font-semibold">
                    Resolved Date
                </div>
                <div class="w-full bg-gray-50 border-y border-r  col-span-1 border-gray-300 px-3 py-1.5 font-semibold">
                    User
                </div>
                <div class="w-full bg-gray-50 border-y border-r text-center  col-span-1 border-gray-300 px-3 py-1.5 font-semibold">
                    Status
                </div>
                <div class="w-full bg-gray-50 border-y border-r  col-span-2 border-gray-300 px-3 py-1.5 font-semibold">
                    Notes
                </div>
                <div class="w-full bg-gray-50 border-y  border-r col-span-1 rounded-tr border-gray-300 px-3 py-1.5 font-semibold">
                    Corresp.
                </div>
            </div>
            <div class=" w-20 h-14  pl-1 py-0.5 flex flex-col justify-between items-end">
                <!-- <button class="bg-dark-secondary text-white hover:bg-dark-primary w-5 h-5 rounded-full"
                    @click="addEventRow" 
                >
                    +
                </button> -->
                <button title="Add open detail" class="bg-dark-secondary text-white hover:bg-dark-primary border  w-full h-6 rounded"
                    @click="addOpenEventRow" 
                >
                + Open
                </button>
                <button title="Add done detail" class="bg-dark-secondary text-white hover:bg-dark-primary border w-full   h-6 rounded"
                    @click="addDoneEventRow" 
                >
                + Done
                </button>
            </div>
        </div>
        <div class="w-full h-full overflow-y-scroll max-h-[calc(100%-16rem)]">
                <TransitionGroup name="events">
                    <CRMEventRow class="draggableRow transition-all duration-100" :ondragstart="crmEvent.resolved_date ? dragstartResolvedDetailHandler : dragstartOpenDetailHandler" :ondragend="dragEndHandler" :ondrop="crmEvent.resolved_date ? dropResolvedDetailHandler : dropOpenDetailHandler"  :ondragover="crmEvent.resolved_date ? dragoverResolvedDetailHandler : dragoverOpenDetailHandler"  :ondragleave="dragLeaveHandler"
                    draggable="true" :data-value="crmEvent.ordinal" :id="crmEvent.id" :drag-due-date="crmEvent.due_date" :drag-resolved-date="crmEvent.resolved_date"
                        v-for="crmEvent in newDetails"
                        :key="crmEvent.id"
                        :crmEvent="crmEvent"
                        :crmEventTypeOptions="crmEventTypeOptions"
                        :userOptions="userOptions"
                        :is-dragging="isDragging"
                        :dragging-due-date="draggingDueDate"
                        :dragging-resolved-date="draggingResolvedDate"
                        @update-event-row="updateEventRow"
                        @remove-event-row="removeEventRow"
                    />
                    <CRMEventRow class="draggableRow transition-all duration-100" :ondragstart="dragstartOpenDetailHandler" :ondragend="dragEndHandler" :ondrop="dropOpenDetailHandler"  :ondragover="dragoverOpenDetailHandler"  :ondragleave="dragLeaveHandler"
                    draggable="true" :data-value="crmEvent.ordinal" :id="crmEvent.id" :drag-due-date="crmEvent.due_date"
                        v-for="crmEvent in orderedOpenDetails"
                        :key="crmEvent.id"
                        :crmEvent="crmEvent"
                        :crmEventTypeOptions="crmEventTypeOptions"
                        :userOptions="userOptions"
                        :is-dragging="isDragging"
                        :dragging-due-date="draggingDueDate"
                        @update-event-row="updateEventRow"
                        @remove-event-row="removeEventRow"
                    />
                    <CRMEventRow class="draggableRow transition-all duration-100" :ondragstart="dragstartResolvedDetailHandler" :ondragend="dragEndHandler" :ondrop="dropResolvedDetailHandler"  :ondragover="dragoverResolvedDetailHandler"  :ondragleave="dragLeaveHandler" 
                    draggable="true" :data-value="crmEvent.ordinal" :id="crmEvent.id" :drag-resolved-date="crmEvent.resolved_date"
                        v-for="crmEvent in orderedEvents"
                        :key="crmEvent.id"
                        :crmEvent="crmEvent"
                        :crmEventTypeOptions="crmEventTypeOptions"
                        :userOptions="userOptions"
                        :is-dragging="isDragging"
                        :dragging-resolved-date="draggingResolvedDate"
                        @update-event-row="updateEventRow"
                        @remove-event-row="removeEventRow"
                    />
                </TransitionGroup>
            <div v-if="showAllStatuses" class="h-72 w-full">

            </div>
        </div>
        <div class="flex w-full justify-center items-center absolute bottom-0 space-x-2 bg-white border-t border-gray-300 h-12">
            <button class="bg-accent-primary text-white hover:bg-accent-secondary px-2 py-1 rounded" @click="updateCRMEvents">Save</button>
            <button class="bg-accent-primary text-white hover:bg-accent-secondary px-2 py-1 rounded" v-if="routeName=='crm-detail-spreadsheet' || routeName=='user-crm-detail-spreadsheet'" @click="updateCRMEventsAndClose">Save and Close</button>
            <button class="bg-dark-secondary text-white hover:bg-dark-primary px-2 py-1 rounded" @click="closeCRMEditForm">Cancel</button>
        </div>
    </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, computed, watch, onUpdated, onMounted } from 'vue';
import { getTodaysDateAsString } from '@/composables/formatDate';
import CRMEventRow from './CRMEventRow.vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { assignCRMDetailOrdinals, getNextCreationSequence, sortCRMDetailsByDueDate, sortCRMDetailsByResolvedDate } from '@/composables/CompanyCRMTools';



const props = defineProps(['company', 'emptyCRMActions', 'crmEventTypeOptions', 'userOptions', 'showAllStatuses', 'companyCampaignId'])

const emit = defineEmits(['update-crm-events', 'update-crm-events-and-close', 'close-crm-edit-form'])

const route = useRoute()

const store = useStore()

// A new row is usually the work of whoever is adding it, so start it off
// assigned to them. Only when they are one of the assignable users though --
// otherwise the User select would sit blank while the row held a user that
// isn't in its options.
const defaultUserId = computed(() => {
    const currentUserId = store.state.auth.user ? store.state.auth.user.id : null
    const isUserOption = props.userOptions ? props.userOptions.some((option) => option.value == currentUserId) : false
    return isUserOption ? currentUserId : null
})

const crmEvents = ref(props.company ? props.company.crm_actions.filter(action => action.campaign.id == props.companyCampaignId).map(action => ({...action, type: 1, action_order: action.action.ordinal})).sort((a, b) => { return a.type - b.type || new Date(b.resolved_date) - new Date(a.resolved_date) || a.action_order - b.action_order }) : [])

const routeName = computed(() => {
    return route.name
})

watch(() => crmEvents.value, () => {
    
}, {deep: true})

const orderedEvents = ref([])
const orderedOpenDetails = ref([])
const newDetails = ref([])

// New rows sit in their own section at the top of the form but get saved into
// the resolved list, so the two have to be numbered as one list -- otherwise
// both start at 1 and the new details fight the existing ones for the same
// slots. Both lists are already in the order the user sees, which is what a
// drag leaves behind, so group them by date instead of re-sorting: newest date
// first, and inside a date the new rows come before the details already saved
// there, since a resolved date group reads newest to oldest.
function getResolvedDetailsInDisplayOrder(){
    const resolvedDates = [...new Set([...orderedEvents.value, ...newDetails.value].map((detail) => detail.resolved_date))]
        .sort((a, b) => new Date(b) - new Date(a))
    return resolvedDates.flatMap((resolvedDate) => [
        ...newDetails.value.filter((detail) => detail.resolved_date == resolvedDate),
        ...orderedEvents.value.filter((detail) => detail.resolved_date == resolvedDate)
    ])
}

function setOrdinals(){
    assignCRMDetailOrdinals(getResolvedDetailsInDisplayOrder())
    assignCRMDetailOrdinals(orderedOpenDetails.value)
}

function orderEvents(){
    orderedEvents.value = crmEvents.value.filter((detail) => detail.resolved_date && detail.type == 1).sort(sortCRMDetailsByResolvedDate)
    orderedOpenDetails.value = crmEvents.value.filter((detail) => !detail.resolved_date).sort(sortCRMDetailsByDueDate)
    newDetails.value = crmEvents.value.filter((detail) => detail.type != 1 && detail.resolved_date).sort(sortCRMDetailsByResolvedDate)
    setOrdinals()
}

orderEvents()

const isDragging = ref(false)
const draggingId = ref(null)
const draggingDueDate = ref(null)
const draggingResolvedDate = ref(null)

function dragoverOpenDetailHandler(ev) {
    ev.preventDefault();
    let target = ev.currentTarget
    const targetDueDate = target.getAttribute("drag-due-date")
    if(targetDueDate == draggingDueDate.value){
        target.classList.add("border")
        target.classList.add("border-dark-primary")
        const currentDragElementOffset = ev.clientY
        const targetDragElementRectangle = ev.currentTarget.getBoundingClientRect()
        const targetDragElementOffset = targetDragElementRectangle.y + (targetDragElementRectangle.height / 2)
        if(currentDragElementOffset < targetDragElementOffset){
            ev.currentTarget.classList.add("translate-y-1")
        }
        if(currentDragElementOffset > targetDragElementOffset){
            ev.currentTarget.classList.add("-translate-y-1")
        }
    }
        ev.dataTransfer.dropEffect = "move"
  }

function dragoverResolvedDetailHandler(ev) {
    ev.preventDefault();
    let target = ev.currentTarget
    const targetResolvedDate = target.getAttribute("drag-resolved-date")
    if(targetResolvedDate == draggingResolvedDate.value){
        target.classList.add("border")
        target.classList.add("border-dark-primary")
        const currentDragElementOffset = ev.clientY
        const targetDragElementRectangle = ev.currentTarget.getBoundingClientRect()
        const targetDragElementOffset = targetDragElementRectangle.y + (targetDragElementRectangle.height / 2)
        if(currentDragElementOffset < targetDragElementOffset){
            ev.currentTarget.classList.add("translate-y-1")
        }
        if(currentDragElementOffset > targetDragElementOffset){
            ev.currentTarget.classList.add("-translate-y-1")
        }
    }
        ev.dataTransfer.dropEffect = "move"
  }
function dragLeaveHandler(ev) {
    ev.preventDefault();
    let target = ev.currentTarget
    target.classList.remove("border")
    target.classList.remove("border-dark-primary")
    target.classList.remove("translate-y-1")
    target.classList.remove("-translate-y-1")
}

  function dropOpenDetailHandler(ev) {
    ev.preventDefault();
    isDragging.value = false
    const currentDragElementOffset = ev.clientY
    const targetDragElementRectangle = ev.currentTarget.getBoundingClientRect()
    const targetDragElementOffset = targetDragElementRectangle.y + (targetDragElementRectangle.height / 2)
    const targetCrmOrdinal = ev.currentTarget.getAttribute("data-value")
    const targetId = ev.currentTarget.getAttribute("id")
    let draggingRow = crmEvents.value.find((row) => row.id == draggingId.value)
    let dropRow = crmEvents.value.find((row) => row.id == ev.currentTarget.id)
    console.log('drag row', draggingRow)
    console.log('drop row', dropRow)
    if(draggingRow.id != dropRow.id && currentDragElementOffset < targetDragElementOffset && (draggingRow.due_date == dropRow.due_date || (!draggingRow.due_date && !dropRow.due_date))){
        let openDetail = orderedOpenDetails.value.find((row) => row.id == draggingId.value)
        if(openDetail){
            console.log('splicing before')
            let draggingRowIdx = orderedOpenDetails.value.findIndex((row) => row.id == draggingId.value)
            orderedOpenDetails.value.splice(draggingRowIdx, 1)
            let dropRowIdx = orderedOpenDetails.value.findIndex((row) => row.id == ev.currentTarget.id)
            orderedOpenDetails.value.splice(dropRowIdx, 0, openDetail)
        }
    } else if(draggingRow.id != dropRow.id && currentDragElementOffset > targetDragElementOffset && (draggingRow.due_date == dropRow.due_date || (!draggingRow.due_date && !dropRow.due_date))){
        let openDetail = orderedOpenDetails.value.find((row) => row.id == draggingId.value)
        if(openDetail){
            let draggingRowIdx = orderedOpenDetails.value.findIndex((row) => row.id == draggingId.value)
            orderedOpenDetails.value.splice(draggingRowIdx , 1)
            let dropRowIdx = orderedOpenDetails.value.findIndex((row) => row.id == ev.currentTarget.id)
            orderedOpenDetails.value.splice(dropRowIdx + 1, 0, openDetail)
        }
    }
    // console.log('drag row after', draggingRow)
    // console.log('drop row after', dropRow)
    setOrdinals()
    draggingId.value = null
    ev.currentTarget.classList.remove('border')
    ev.currentTarget.classList.remove('border-dark-primary')
    ev.currentTarget.classList.remove("translate-y-1")
    ev.currentTarget.classList.remove("-translate-y-1")
    orderEvents()
  }

function dropResolvedDetailHandler(ev) {
    ev.preventDefault();
    isDragging.value = false
    const currentDragElementOffset = ev.clientY
    const targetDragElementRectangle = ev.currentTarget.getBoundingClientRect()
    const targetDragElementOffset = targetDragElementRectangle.y + (targetDragElementRectangle.height / 2)
    const targetCrmOrdinal = ev.currentTarget.getAttribute("data-value")
    const targetId = ev.currentTarget.getAttribute("id")
    let draggingRow = crmEvents.value.find((row) => row.id == draggingId.value)
    let dropRow = crmEvents.value.find((row) => row.id == ev.currentTarget.id)
    console.log('drag row', draggingRow)
    console.log('drop row', dropRow)
    if(draggingRow.id != dropRow.id && currentDragElementOffset < targetDragElementOffset && (draggingRow.resolved_date == dropRow.resolved_date)){
        let resolvedDetail = orderedEvents.value.find((row) => row.id == draggingId.value)
        let resolvedNewDetail = newDetails.value.find((row) => row.id == draggingId.value)
        if(resolvedDetail){
            console.log('splicing before')
            let draggingRowIdx = orderedEvents.value.findIndex((row) => row.id == draggingId.value)
            orderedEvents.value.splice(draggingRowIdx, 1)
            let dropRowIdx = orderedEvents.value.findIndex((row) => row.id == ev.currentTarget.id)
            orderedEvents.value.splice(dropRowIdx, 0, resolvedDetail)
        } else if(resolvedNewDetail) {
            console.log('splicing before')
            let draggingRowIdx = newDetails.value.findIndex((row) => row.id == draggingId.value)
            newDetails.value.splice(draggingRowIdx, 1)
            let dropRowIdx = newDetails.value.findIndex((row) => row.id == ev.currentTarget.id)
            newDetails.value.splice(dropRowIdx, 0, resolvedNewDetail)
        }
    } else if(draggingRow.id != dropRow.id && currentDragElementOffset > targetDragElementOffset && (draggingRow.resolved_date == dropRow.resolved_date)){
        let resolvedDetail = orderedEvents.value.find((row) => row.id == draggingId.value)
        let resolvedNewDetail = newDetails.value.find((row) => row.id == draggingId.value)
        if(resolvedDetail){
            let draggingRowIdx = orderedEvents.value.findIndex((row) => row.id == draggingId.value)
            orderedEvents.value.splice(draggingRowIdx , 1)
            let dropRowIdx = orderedEvents.value.findIndex((row) => row.id == ev.currentTarget.id)
            orderedEvents.value.splice(dropRowIdx + 1, 0, resolvedDetail)
        } else if(resolvedNewDetail){
            let draggingRowIdx = newDetails.value.findIndex((row) => row.id == draggingId.value)
            newDetails.value.splice(draggingRowIdx , 1)
            let dropRowIdx = newDetails.value.findIndex((row) => row.id == ev.currentTarget.id)
            newDetails.value.splice(dropRowIdx + 1, 0, resolvedNewDetail)
        }
    }
    // console.log('drag row after', draggingRow)
    // console.log('drop row after', dropRow)
    setOrdinals()
    draggingId.value = null
    ev.currentTarget.classList.remove('border')
    ev.currentTarget.classList.remove('border-dark-primary')
    ev.currentTarget.classList.remove("translate-y-1")
    ev.currentTarget.classList.remove("-translate-y-1")
    orderEvents()
  }

function dragstartOpenDetailHandler(ev) {
    draggingId.value = ev.target.id
    // const companyId = ev.target.id
    isDragging.value = true
    // console.log('drag starting with id', ev.target.id)
    ev.dataTransfer.effectAllowed = "move";
    ev.dataTransfer.dropEffect = "move"
    const crmDetailOrdinal = ev.target.getAttribute('data-value')
    let draggingRow = crmEvents.value.find((row) => row.id == ev.target.id)
    draggingDueDate.value = draggingRow.due_date
    ev.dataTransfer.setData("text/plain", JSON.stringify({crmDetailId: ev.target.id, crmDetailOrdinal: crmDetailOrdinal}));
}

function dragstartResolvedDetailHandler(ev) {
    draggingId.value = ev.target.id
    // const companyId = ev.target.id
    isDragging.value = true
    // console.log('drag starting with id', ev.target.id)
    ev.dataTransfer.effectAllowed = "move";
    ev.dataTransfer.dropEffect = "move"
    const crmDetailOrdinal = ev.target.getAttribute('data-value')
    let draggingRow = crmEvents.value.find((row) => row.id == ev.target.id)
    // console.log('dragging row', draggingRow)
    draggingResolvedDate.value = draggingRow.resolved_date
    console.log('dragging resolved date', draggingResolvedDate.value)
    ev.dataTransfer.setData("text/plain", JSON.stringify({crmDetailId: ev.target.id, crmDetailOrdinal: crmDetailOrdinal}));
}

function dragEndHandler(ev) {
    // console.log('drag ended')
    isDragging.value = false
    draggingId.value = null
    draggingDueDate.value = null
    draggingResolvedDate.value = null
    ev.currentTarget.classList.remove('border')
    ev.currentTarget.classList.remove('border-dark-primary')
    ev.currentTarget.classList.remove("translate-y-1")
    ev.currentTarget.classList.remove("-translate-y-1")
}



const campaignId = computed(() => {
    return props.company.campaign ? props.company.campaign.id : null
})


function updateCRMEvents() {
    // Number the rows one last time before saving -- dates typed into a row
    // after it was added can move it into another group, and rows only get
    // re-placed and re-numbered when the list is re-ordered.
    orderEvents()
    emit('update-crm-events', crmEvents.value)
    // emit('close-crm-edit-form')
}


function updateCRMEventsAndClose() {
    orderEvents()
    emit('update-crm-events-and-close', crmEvents.value)
    // emit('close-crm-edit-form')
}

function closeCRMEditForm() {
    emit('close-crm-edit-form')
}


function addOpenEventRow() {
    const newEventRow = {
        id: Math.floor(Math.random() * -100000),
        // action_name: null,
        action_id: null,
        resolved_date: null,
        due_date: null,
        status: null,
        user_id: defaultUserId.value,
        action_notes: null,
        action_details: null,
        campaign_id: campaignId.value,
        type: 0,
        action_order: 22,
        ordinal: null,
        creation_sequence: getNextCreationSequence()
    }
    crmEvents.value.splice(0, 0, newEventRow)
    orderEvents()
    return newEventRow
}

function addDoneEventRow() {
    const newEventRow = {
        id: Math.floor(Math.random() * -100000),
        // action_name: null,
        action_id: null,
        resolved_date: getTodaysDateAsString(),
        due_date: null,
        status: null,
        user_id: defaultUserId.value,
        action_notes: null,
        action_details: null,
        campaign_id: campaignId.value,
        type: 0,
        action_order: 22,
        ordinal: null,
        creation_sequence: getNextCreationSequence()
    }
    crmEvents.value.splice(0, 0, newEventRow)
    orderEvents()
    return newEventRow
}

function removeEventRow(eventId) {
    // console.log('removeRow', eventId)
    let rowIndex = crmEvents.value.findIndex((row) => row.id == eventId)
    crmEvents.value.splice(rowIndex, 1)
    orderEvents()
}

function updateEventRow(eventRow) {
    // console.log('CRMViewPort: updateRow')
    // console.log(eventRow)
    let existingRow = crmEvents.value.find((row) => row.id == eventRow.id)
    // existingRow.action_name = eventRow.action_name
    // console.log('eventRow')
    // console.log(eventRow)
    // A row that just got a different date belongs at the end of whichever
    // group it moved into, so drop the slot it held in the group it left.
    const changedDates = existingRow.resolved_date != eventRow.resolved_date || existingRow.due_date != eventRow.due_date
    if(changedDates){
        existingRow.ordinal = null
    }
    existingRow.action = eventRow.action
    existingRow.action_id = eventRow.action_id
    existingRow.resolved_date = eventRow.resolved_date
    existingRow.due_date = eventRow.due_date 
    // existingRow.status = eventRow.status 
    existingRow.user_id = eventRow.user_id
    existingRow.user = null
    existingRow.action_notes = eventRow.action_notes 
    existingRow.action_details = eventRow.action_details 
    existingRow.action_order = eventRow.action_order
    existingRow.type = eventRow.type
    existingRow.campaign_id = campaignId.value
}

</script>

<style scoped>
.events-move,
.events-enter-active {
    transition: all 0.1s ease;
}
.events-leave-active {
  transition: all 0.08s ease;
}
.events-enter-from,
.events-leave-to {
  opacity: 0;
  transform: translateX(-10px);
}

.events-leave-active {
    position: relative;
    /* position: relative; */
}
</style>